import {
    serializable,
    DynamicFormControlLayout,
    DynamicInputModel,
    DynamicInputModelConfig,
	MATCH_VISIBLE,
} from "@ng-dynamic-forms/core";
import { Model_WorkflowComponent, CODE_WORKFLOW_COMPONENT, TYPE_DATASOURCE, TYPE_DEFAULT_VALUE, TYPE_WORKFLOW_COMPONENT_OBSERVER, EXPRESSION_FIELD_SCOPE, FONCTION_WORKFLOW_COMPONENT_OPTIONS, SAGE_DOMAINES_OPTIONS, SAGE_DOMAINE, SAGE_TYPES_DOCUMENTS_OPTIONS, SAGE_TYPE_DOCUMENT } from 'src/app/app.models';
import { COMPONENT_MODE } from '../../workflow-components.models';
import { WorkflowComponentBuilderOptions } from '../../workflow-components.service';
  
export interface SoudotecItemsInputModelConfig extends DynamicInputModelConfig {
	componentMode: COMPONENT_MODE; 
}
  
export class SoudotecItemsInputModel extends DynamicInputModel {
	@serializable() readonly type: string = 'soudotec_items_input';
	componentMode: COMPONENT_MODE;
	constructor(config: SoudotecItemsInputModelConfig, layout?: DynamicFormControlLayout) {
		super(config, layout);
		this.componentMode = config.componentMode;
	}

	static initModel(_component: any): SoudotecItemsInputModel {
		const formModel = new SoudotecItemsInputModel({
			id: _component.ID,
			name: _component.ID,
			label: _component.LABEL,
			value: _component.DEFAULT_VALUE,
			required: _component.IS_REQUIRED,
			readOnly: _component.IS_READONLY,
			hidden: _component.IS_VISIBLE !== undefined ? _component.IS_VISIBLE === false : false,
			validators: _component.CUSTOM_VALIDATORS,
			componentMode: _component.COMPONENT_MODE,
            additional: _component,
			relations: _component.RELATIONS,
		});
		return formModel;
	}

	static getProperties(_options?: WorkflowComponentBuilderOptions): Model_WorkflowComponent {	
		return {
			ID: 'soudotec_items_input',
			CODE: CODE_WORKFLOW_COMPONENT.SOUDOTEC_ITEMS_INPUT,
			ICON: 'duplicate-outline',
			LABEL: '[SOUDOTEC] - Saisie d\'articles',
			HAS_DATASOURCE: true,
			CODE_SOCIETE: 'SOUDOTEC',
			PROPERTIES: [
				{ ID: 'GUID', CODE: CODE_WORKFLOW_COMPONENT.TEXTBOX, LABEL: 'GUID', IS_VISIBLE: false },
				{ ID: 'INDEX', CODE: CODE_WORKFLOW_COMPONENT.NUMERIC_TEXTBOX, LABEL: 'Index', DEFAULT_VALUE: 1 },
				{ ID: 'ID', CODE: CODE_WORKFLOW_COMPONENT.TEXTBOX, LABEL: 'Identifiant', IS_REQUIRED: true, CUSTOM_VALIDATORS: [{ VALIDATOR_NAME: 'no_whitespace' }] },
				{ ID: 'LABEL', CODE: CODE_WORKFLOW_COMPONENT.TEXTBOX, LABEL: 'Libellé', IS_REQUIRED: true },
				{ ID: 'IS_VISIBLE', CODE: CODE_WORKFLOW_COMPONENT.TOGGLE, LABEL: 'Est Visible ?', DEFAULT_VALUE: true },
				{ ID: 'IS_REQUIRED', CODE: CODE_WORKFLOW_COMPONENT.TOGGLE, LABEL: 'Est Requis ?' },
				{ ID: 'GRID_COLUMNS', CODE: CODE_WORKFLOW_COMPONENT.INPUT_GRID_COLUMNS_BUILDER, LABEL: 'Colonnes', IS_VISIBLE: false, DEFAULT_VALUE: [
					{ ID: 'AR_CodeBarre', CODE: CODE_WORKFLOW_COMPONENT.TEXTBOX, LABEL: 'Code Barre' },
					{ ID: 'AR_Ref', CODE: CODE_WORKFLOW_COMPONENT.TEXTBOX, LABEL: 'Ref Article' },
					{ ID: 'AR_Design', CODE: CODE_WORKFLOW_COMPONENT.TEXTBOX, LABEL: 'Désignation' },
					{ ID: 'FA_CodeFamille', CODE: CODE_WORKFLOW_COMPONENT.TEXTBOX, LABEL: 'Code Famille' },
					{ ID: 'FA_Intitule', CODE: CODE_WORKFLOW_COMPONENT.TEXTBOX, LABEL: 'Famille' },
					{ ID: 'QUANTITE', CODE: CODE_WORKFLOW_COMPONENT.TEXTBOX, LABEL: 'Quantité' },
				] },
			]
		};
	}
}
  